import React from 'react';

// Интерфейс для отдельного предложения (товара)
interface ListingItem {
  listing_id: number;
  url?: string;
  MainImage?: {
    url_570xN: string;
  };
  title?: string;
  currency_code?: string;
  price?: string;
  quantity?: number;
  state?: string;
}

// Интерфейс для пропсов компонента Listing
interface ListingProps {
  items: ListingItem[];
}

const Listing: React.FC<ListingProps> = ({ items = [] }) => {
  // Функция для форматирования цены
  const formatPrice = (price: string, currency: string) => {
    switch (currency) {
      case 'USD':
        return `$${price}`;
      case 'EUR':
        return `€${price}`;
      case 'GBP':
        return `£${price}`;
      default:
        return `${currency} ${price}`;
    }
  };

  // Функция для определения класса количества
  const getQuantityClass = (quantity: number) => {
    if (quantity <= 10) return 'stock-low';
    if (quantity <= 20) return 'stock-medium';
    return 'stock-high';
  };

  return (
    <div className="item-list">
      {items.map((item) => {
        // Пропускаем элементы без картинки или удаленные (если такие есть в JSON)
        if (!item.MainImage || !item.title) return null;

        // Обрезание названия до 50 символов
        const title = item.title.length > 50 
          ? `${item.title.slice(0, 50)}…` 
          : item.title;

        return (
          <div className="product-card" key={item.listing_id}>
            <div className="product-image">
              <a href={item.url}>
                <img src={item.MainImage.url_570xN} alt={item.title} />
              </a>
            </div>
            <div className="product-info">
              <h3 className="product-title" title={item.title}>
                {title}
              </h3>
              <div className="price-container">
                <div className="product-price">
                  {formatPrice(item.price || '0', item.currency_code || '')}
                </div>
                <span className={`stock-badge ${getQuantityClass(item.quantity || 0)}`}>
                  {item.quantity} left
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Listing;
